import { Autocomplete, Backdrop, Button, Dialog, Grid, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModalTable from "../../../../../components/utils/modalTable/modalTable";
import CashCloseTable from "../../../../../components/utils/modalTable/cashCloseTable";
import { date } from "yup";
import { Delete, Print } from "@mui/icons-material";
import { onPressButton, setThermalData } from "../../../../../components/hooks/printPdf/thermalData";
import { useNavigate } from "react-router-dom";
import OtToOtTransferTable from "../../../../../components/utils/modalTable/otToOtTransferTable";
import CustomTable from "../../reports/customTable";
import ApproveModal from "./approvalmodal";

const PurchaseReturnApprovel = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [rowData, setRowData] = useState(null)
  const [supplier, setSupplier] = useState([]);
  const navigate = useNavigate()
  const[salesLines , setSalesLines] = useState([])
  const [open , setOpen] = useState(false)
  const [companyData , setCompanyData] = useState([])
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
    const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
    const roleId = localStorage.getItem("role_id")
    const outletName = localStorage.getItem('outlet_name')
    const outletId = localStorage.getItem('outlet_id')
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().format(),
    // fromDate : moment().subtract(1 , 'months').format(),
    toDate :  moment().format()
  })
  const[cust, setCust] = useState(null)
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [docNo, setDocNo] = useState('')
  const[status, setStatus] = useState()
  const [activeId, setActiveId] = useState(null)
  const [selectedDocNo, setSelectedDocNo] = useState(null);
  const fixedOutlet = { id: outletId, fullname: outletName };
  const onEdit = (e) => {
    console.log("Selected row data:", e.row); // Check the structure of the row

    setSalesLines(e.row.pr_lines)

    setRowData(e.row)
    setOpen(true)
  }

  console.log(salesLines,"pr_lines")
console.log(pageCount,rowsPerPage,page,"rowsPerPage");

const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 100,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  {
    field: "docno",
    headerName: "Doc No",
    minWidth: 250,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "date1",
    headerName: "Date",
    minWidth: 230,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "amount",
    headerName: "Amount",
    minWidth: 100,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field:"totalqty",
    headerName: "Total Qty",
    minWidth: 180,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field:"approve",
    headerName: "Status",
    minWidth: 180,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

{
    field: "view",
    headerName: "View",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
    disableExport: true ,
    renderCell: (params) => {
      const isApproved = params.row.is_approved === 1;
      console.log(isApproved,"isApproved");
      
      return (
        <div>
          <IconButton size="small" onClick={() => onEdit(params)}><VisibilityIcon /></IconButton>
            {/* <IconButton size="small" onClick={()=>handleThermal(params.row)}><Print sx={{fontSize: 18}}/></IconButton> */}
     {/* <IconButton onClick={() => OnDelete(params.id)}>
          <Delete sx={{color:"red",fontSize:22}}/>
        </IconButton> */}
           <IconButton 
     disabled={isApproved}          
  onClick={() => OnDelete(params)}>
        <Delete  sx={{ color: isApproved ? "gray" : "red", fontSize: 22 }} />
      </IconButton>
        </div>
        
      );
    },
  },
]
// function OnDelete(id){
//   setOpenDialog(true)
//   setActiveId(id)
// console.log(id,"deleteid");

// }    
function OnDelete(params) {
  const docno = params.row.docno; // Extract docno from the selected row
  setSelectedDocNo(docno); // Store the docno in state
  setOpenDialog(true);
  console.log(docno, "delete docno");
}
  function handleThermal(e){
    console.log('Working!',e)
    console.log(e)
    const textData = {
      tot:e.tot,
      date:e.documentDate,
      employee:e.salesManName,
      opening_balance:e.opening_balance,
      expences_amount:e.expences_amount
    }
    const tableData = _.map(e.pr_lines, ((val , idx)=>({ 
      sno:++idx,
     denomination:val.denomination,
     count:val.count,
     total:val.total
    })))
    console.log(tableData)
    console.log(textData)
   
    dispatch(setThermalData({
      tableData : tableData,
      TotalData : textData,
      companyInfo:cust
    }))      
    dispatch(onPressButton())
    const name = `ExpenseBill`
    navigate(`/expenseClose/${name}`)  
   
        }
        console.log(cust)
        const getStatus =(row)=>{
  const isApproved = row.is_approved === 1;
  const isApprovedfalse = row.is_approved === 0;
if (isApproved) return "Approved";
if (isApprovedfalse) return "Un Approve";
return "N/A";
}
const rows = _.map(data,(val,idx)=>({
  id: val.id,
  sno: idx+1,
  // date1 : val.docdate,
  // date1 : val.date,
    date1 : moment(val.date).format("DD-MM-YYYY"),
  docno : val.docno,
  suppliername:val.supplier_name,
  totalqty : val.totalqty,
  totalamt:val.total_amt,
  totalgst:val.total_gst,
  // approve: val.is_approved,
  approve:getStatus(val),
  prodid:val.prodid,
  party : val.fullname,
  amount:val.amount,
  mobile:val.mobile,
  tot: parseFloat(val.amount).toFixed(2),
  pr_lines:val.pr_lines,
  closing_balance:val.closing_balance,
  documentDate:moment(val.date).format("DD-MM-YYYY"),
  outlet_id:val?.outlet_id,
  is_approved: val.is_approved, 
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
console.log(rows,"rows");


useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.amount);
  });
  setTotalAmount(total.toFixed(2));
}, [data]);
const tableHeadData = [
  { id:1, label: "S No" },
  { id:2, label: "Doc No" },
  { id:3 , label:"Date"},
  { id:4 , label : "Po Name"},
  // { id:5, label:"Po Code"},
  { id:5 , label:"Barcode"},
  { id:6 , label:"Amount"},
  { id:7 , label:"Rate"},
  { id:8 , label:"Qty"},
  // { id:9 , label:"Qty"},
];
console.log(salesLines,"salesLines")

const tableBodyData = _.map(salesLines, (val,idx) => ({
      // id:idx,
      id: `${val?.docno ?? ''}_${val?.prodid ?? ''}_${val?.barcode ?? ''}_${idx}`,
      sNo: idx + 1,
      docno: val?.docno,
      date: val?.date,
      proName: val?.pro_name,  // Access from pr_lines
      pro_code: val?.pro_code,  // Access from pr_lines
      qty: val?.qty,  // Access from pr_lines
      date: moment(val.podate).format("YYYY-MM-DD"),
      purchase_rate: val?.purchase_rate,  // Access from pr_lines
      order_qty: val?.order_qty,  // Access from pr_lines
      amount:val?.amount,
      barcode:val?.barcode,
      // prodid:val?.prodid,
      prodid:val?.prodid ?? val?.prod_id,
      total_gst:val?.total_gst,
      rate:val?.rate,
      is_approved:val?.is_approved,
      pr_lines: val.pr_lines,  // Include pr_lines
    // }));
  }));
  const flattenedData = _.flatten(tableBodyData);

  console.log("Table body data:", flattenedData);
  
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        setSupplier(res.data);
        _.filter(res.data,val=>val.id== outletId).map(val=>setCust(val))
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }

function handleSalesReturn() {
    if (!dateLimit || !dateLimit.fromDate || !dateLimit.toDate) {
      console.error("Date range is missing");
      return;
    }
    const approvestatus = status ? (status.id === 0 ? 0 : status.id) : 0; // 0: All, 1: Generated, 2: Verified

    // Format the dates
    const fromDate = moment(dateLimit.fromDate).format('YYYY-MM-DD');
    const toDate = moment(dateLimit.toDate).format('YYYY-MM-DD');
  
    // Construct the dynamic URL
    const url = `v1/pr/outlet/fetch/${rowsPerPage}/${page}?from_date=${fromDate}&to_date=${toDate}&outlet_id=${cust?.id}`;
    // const url = `v1/wastage/outlet/${fromDate}/${toDate}`;
  
    const postData = {
      customer: cust?.id || fixedOutlet?.id,
    };
  
    // setLoading(true); // Add loading state if applicable
    axios
      .get(url, )
      .then((res) => {
        const responseData = res.data.data || []; // Access the 'data' array in the response
    setData(responseData);
        // setData(res.data?.[0] || []);
        setPageCount(res.data?.length || 0);
        // setSalesLines(res.data);
        console.log(res.data.data[0], "dataajayyyyyyyyy");
      })
      .catch((err) => {
        console.error(err);
        setData([]);
        // Uncomment to show snackbar notification
        // dispatch(setSnackbar(true, "error", err.response?.data?.errors?.[0]?.message || "An error occurred"));
      })
      .finally(() => {
        // setLoading(false); // Reset loading state
      });
  }

const handleTransferApproved = (row) => {
    setSelectedRow(row);  // Set the selected row for approval
    setOpenDialog(true);  // Open the modal
};

const handledelete = () => {
  const payload = {
    docno: selectedDocNo, // Include the selected docno in the payload
  };
  console.log(payload, "payload for deletion");

  axios
    .delete('/v1/pr/outlet/delete', { data: payload }) // Pass payload in the data property
    .then((res) => {
      dispatch(setSnackbar(true, "success", "Deleted successfully!"));
      handleSalesReturn(); // Refresh data after deletion
      setOpenDialog(false); // Close the modal after success
      setOpen(false);
    })
    .catch((err) => {
      const errorMessage =
        err.response?.data?.errors?.[0]?.message || "Something went wrong";
      dispatch(setSnackbar(true, "error", errorMessage)); // Show error message
      setOpenDialog(false); // Close the modal after error
    });
};

console.log(data)
  useEffect(() => {
    getSupplierData();
  }, []);
  
  useEffect(()=>{
    if( dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleSalesReturn()
      console.log('Vanthuden')
    }
  },[rowsPerPage, page, dateLimit, cust,status])
  console.log(roleId != 2 )
  console.log(data,"ajayyyyyyyyy");
  
  return (
    <Fragment>
      <Helmet><title>Purchase Return Approval</title></Helmet>
      <Typography variant="h6">Purchase Return Approval</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
                 <Autocomplete 
                   size="small"
                   value={cust}
                   options={supplier}
                   onChange={(e,value)=>setCust(value)}
                   getOptionLabel={option=>option.fullname}
                   disabled={roleId != 1 && roleId != 2} 
                   renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
                 />
               </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              disabled={roleId != 1 && roleId != 2}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              disabled={roleId != 1 && roleId != 2}
              format="DD-MM-YYYY"
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
          {/* <Grid item md={3}>
            <Autocomplete
              size="small"
              options={[
                { id: 0, fullname: "All" },
                { id: 2, fullname: "Approved" },
                { id: 1, fullname: "Un approved" },
              ]}
              disableClearable
              value={status}
              onChange={(e, value) => setStatus(value)} // Update status
              getOptionLabel={(option) => option.fullname}
              renderInput={(params) => <TextField {...params} placeholder="Select Status" />}
            />
          </Grid> */}
      </Grid>
      
      <CustomTable props={props}/>
      <Backdrop open={open} sx={{ zIndex: 1300 }}>
        <ApproveModal  cust={cust} setSelectedRow={setSelectedRow} setOpenDialog={setOpenDialog}handleTransferApproved={handleTransferApproved}tableHeadData={tableHeadData} flattenedData={flattenedData} tableBodyData={tableBodyData} setOpen={setOpen} data={rowData} handleSalesReturn={handleSalesReturn}  sx={{ zIndex: 1350 }}/>
      </Backdrop>
      <Dialog  sx={{ zIndex: 1400 }} open={openDialog} onClose={() => setOpenDialog(false)}>
      <Grid className='bg-white p-5'>
            <Typography variant='h5'>Are you sure you want to delete?</Typography>
            <Grid className='flex justify-center mt-5'>
                <Button variant='outlined' onClick={() => setOpenDialog(false)}>Cancel</Button>
                <div>
                    <Button
                        variant='contained'
                        sx={{ marginInline: 2, backgroundColor: 'red !important' }}
                        onClick={handledelete} 
                    >
                        Confirm
                    </Button>
                </div>
            </Grid>
        </Grid>
             
            </Dialog>
    </Fragment>
  );
};

export default memo(PurchaseReturnApprovel);
